/*
 *   File : header.js
 *   Author : https://evoqins.com
 *   Description : Header component
 *   Integrations : js-cookie
 *   Version : 1.0.0
*/

import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import Cookies from "js-cookie";
import { Offcanvas } from 'bootstrap';

//Custom components
import { Icon } from '../Icon';

// Styles
import Colors from "../../Styles/color.scss";
import { OverLay } from '../Others';
import LeftNavigationWidget from './left-navigation';

const HeaderNavigation = (props) => {

    const navigate = useNavigate();
    const location = useLocation();
    let pathname = location.pathname.split("/");
    const USER_DATA = useSelector((store) => store.Reducer);
    const dispatch = useDispatch();

    const [showLogout, setShowLogout] = useState(false);
    const [showOffCanvas, setShowOffcanvas] = useState(false);

    useEffect(() => {
        if (showOffCanvas) {

            const side_menu = new Offcanvas(document.getElementById('offcanvas-side-menu'));
            side_menu.show();

            let offcanvas = document.getElementById("offcanvas-side-menu");
            offcanvas.addEventListener("hidden.bs.offcanvas", () => {
                setShowOffcanvas(false);
            });
        }

        window.addEventListener("resize", () => {
            let close_btn = document.querySelector("#offcanvas-close-btn");
            if (window.innerWidth > 576 && showOffCanvas === true && close_btn) {
                close_btn.click();
            }
        });

    }, [showOffCanvas]);

    // handle navigate to login page
    const _handleNavigateToLogin = () => {
        navigate("/login");
    };

    // handle navigate to login page
    const _handleNavigateToHome = () => {
        navigate("/");
    };

    // handle show side navigation menu
    const _handleShowSideMenu = () => {
        setShowOffcanvas(true);
    };

    // handle navigate notification 
    const _handleLogout = () => {
        setShowLogout(false);
        let options = { domain: process.env.REACT_APP_DOMAIN, path: '/' };
        dispatch({ type: "CLEAR_STORE" });
        Cookies.remove("indvestment_access_token", options);
        Cookies.remove("indvestment_user_id", options);
        Cookies.remove("indvestment_token_expiry_time", options);
        localStorage.removeItem("indvestment_refresh_token");
        localStorage.removeItem("indvestment_connected_broker");
        localStorage.removeItem("indvestment_is_lumpsum_broker");
        navigate("/login");
    };

    return (
        props.type === 1 ?
            <div className='padding-16px-lr-res col py-4 padding-72px-lr e-bg-magnolia e-border-bottom-1px-anti-flash-white'>
                <div className='d-flex justify-content-between align-items-center flex-wrap gap-2 py-0'>
                    <img src={require("../../Assets/Images/Navigation/indvestment-logo.svg").default}
                        draggable={false}
                        className='w-100px-res w-144px cursor-pointer'
                        alt='indvestment-logo'
                        onClick={_handleNavigateToHome} />
                    <div className='d-flex align-items-center gap-32px flex-wrap'>
                        <Icon icon="bookmark"
                            color={pathname.includes("watchlist") ? Colors.ocean_blue : ""}
                            className="d-none d-sm-block  cursor-pointer w-24px w-16px-res"
                            onClick={() => navigate("/watchlist")}
                        />
                        {/* Notification count */}
                        {/* <span className='d-none d-sm-block position-relative cursor-pointer'
                            onClick={() => navigate("/notifications")}>
                            <Icon icon="notification-icon"
                                color={pathname.includes("notifications") ? Colors.ocean_blue : ""}
                                className="cursor-pointer w-22px w-16px-res" />
                            <span className='d-flex justify-content-center e-text-white e-alt-font-lato e-font-weight-700 e-bg-red e-font-8 line-height-10px w-16px h-30px position-absolute top-0 start-50 ms-2 translate-middle badge rounded-circle'>
                                {USER_DATA.UNREAD_NOTIFICATION || 4}
                            </span>
                        </span> */}

                        {/* Hamburger Menu icon */}
                        <img src={require("../../Assets/Images/Icons/General/hamburger.png")}
                            draggable={false}
                            alt='hamburger-menu'
                            aria-controls="offcanvas-side-menu"
                            className='mt-1 d-sm-none cursor-pointer'
                            width={20}
                            height={16}
                            onClick={_handleShowSideMenu} />

                        <div className="position-relative">
                            <Icon icon="menu-icon"
                                className="cursor-pointer w-24px w-16px-res"
                                onPress={() => setShowLogout(prev => !prev)} />
                            {
                                showLogout &&
                                <>
                                    <OverLay isOpen={showLogout} onClose={() => setShowLogout(false)} />
                                    <div id='header-logout'
                                        className='position-absolute top-100 end-0 mt-3 e-bg-white border-radius-8 w-162px padding-10px-tb padding-12px-lr z-index-999'>
                                        <span className='d-flex gap-2 align-items-center cursor-pointer'
                                            onClick={_handleLogout}>
                                            <Icon icon="logout"
                                                className="w-18px w-16px-res" />
                                            <span className='e-text-eerie-black e-alt-font-lato e-font-weight-400 e-font-14 line-height-20px'>
                                                Logout
                                            </span>
                                        </span>
                                    </div>
                                </>
                            }
                        </div>

                        {/* Off canvas menu */}
                        {
                            showOffCanvas &&
                            <div className="offcanvas offcanvas-start"
                                data-bs-scroll="false"
                                tabIndex="-1"
                                id="offcanvas-side-menu"
                                aria-labelledby="offcanvas-side-menu">
                                <div className="offcanvas-header px-2 d-flex justify-content-between">
                                    <img src={require("../../Assets/Images/Navigation/indvestment-logo.svg").default}
                                        draggable={false}
                                        data-bs-dismiss="offcanvas"
                                        className='w-100px-res w-144px cursor-pointer'
                                        alt='indvestment-logo'
                                        onClick={_handleNavigateToHome} />
                                    <button id="offcanvas-close-btn"
                                        data-bs-dismiss="offcanvas"
                                        className='text-reset border-0 bg-transparent p-0 m-0'>

                                        <Icon icon="close-icon"
                                            size={20}
                                            aria-label="Close" />
                                    </button>
                                </div>
                                <div className="offcanvas-body pb-0 p-2">
                                    <LeftNavigationWidget type={2} />
                                </div>
                            </div>
                        }

                    </div>


                </div>
            </div>
            :
            <div className='bg-transparent'>
                <div className='container'>
                    <div className='d-flex flex-column  row-gap-4 flex-md-row justify-content-between align-items-center py-4'>
                        <div>
                            <img src={require("../../Assets/Images/Navigation/indvestment-logo.svg").default}
                                draggable={false}
                                alt='logo'
                                className='cursor-pointer'
                                onClick={_handleNavigateToLogin} />
                        </div>
                        <div className='d-flex align-items-center gap-3 gap-md-5 flex-wrap'>
                            <div className='d-flex gap-2 align-items-center'>
                                <Icon icon={"e-mail"}
                                    size="20px" />
                                <a href='mailto:hello@indvestment.com' className='pt-1 e-primary-font-clash-display e-text-chinese-black e-font-16 e-font-weight-400 line-height-20px text-decoration-none text-decoration-hover-underline'>
                                    hello@indvestment.com
                                </a>
                            </div>
                            <div className='d-flex gap-2 align-items-center'>
                                <Icon icon={"phone-icon"}
                                    size="20px" />
                                <a href='tel:+919876543210' className='pt-1 e-primary-font-clash-display e-text-chinese-black e-font-16 e-font-weight-400 line-height-20px text-decoration-none text-decoration-hover-underline'>
                                    +91-98765 43210
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
    )
}

export default HeaderNavigation;
